import type { ElasticSearchSortOptions } from '@modules/search';
import type { SyntheticEvent } from 'react';

export const scrollToEventElement = (event: SyntheticEvent<HTMLElement>) => {
    (event.target as HTMLElement).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
    });
};

export const getSortOptions = (showPriceSortBy = false) => {
    const sortOptions: {
        item: string;
        param: ElasticSearchSortOptions;
    }[] = [
        { item: 'Popular', param: 'popular' },
        { item: 'New', param: 'created' },
        { item: 'Trending', param: 'trending' },
        { item: 'Price (Low first)', param: 'lowPrice' },
        { item: 'Price (High first)', param: 'highPrice' },
        { item: 'Recently updated', param: 'updated' },
        { item: 'A-Z', param: 'alphabetical' },
    ];

    return sortOptions.filter((option) => {
        if (
            !showPriceSortBy &&
            (option.param === 'lowPrice' || option.param === 'highPrice')
        ) {
            return false;
        }
        return true;
    });
};
